import styled, { FlattenSimpleInterpolation } from 'styled-components'
import { vars } from '@machobear/design-system/css'
import { Box } from '@/components/structure'
import { CssUnit } from '@/types'
import LivLogo from './logo.svg?react'

interface Props {
  circle?: boolean
  borderRadius?: CssUnit
  height?: CssUnit
  width?: CssUnit
  showLogo?: boolean
  inline?: boolean
  top?: CssUnit
  bottom?: CssUnit
  right?: CssUnit
  left?: CssUnit
  customStyle?: FlattenSimpleInterpolation | undefined
}

const Wrapper = styled.span<Props>`
  @keyframes skeletonAnimation {
    0% {
      opacity: 0.4;
    }
    50% {
      opacity: 0.9;
    }

    100% {
      opacity: 0.4;
    }
  }

  display: ${props => (props.inline ? 'inline-flex' : 'flex')};
  justify-content: center;
  align-items: center;
  background-color: ${vars.backgroundColor.neutralSoftHover};

  background-size: 200px 100%;
  background-repeat: no-repeat;
  border-radius: ${props => (props.circle ? '50%' : `${props.borderRadius}px`)};
  line-height: 1;
  width: 100%;
  height: 100%;
  animation: skeletonAnimation 1.6s ease-in-out infinite;
  ${({ customStyle }) => customStyle};
`

const Skeleton: React.FC<Props> = ({
  circle = false,
  borderRadius = 4,
  top,
  bottom,
  right,
  left,
  height,
  width,
  showLogo,
  ...rest
}) => {
  return (
    <Box width={width} height={height} top={top} bottom={bottom} left={left} right={right}>
      <Wrapper circle={circle} borderRadius={borderRadius} {...rest}>
        &zwnj;
        {showLogo && <LivLogo width={72} height={101} />}
      </Wrapper>
    </Box>
  )
}

export default Skeleton
